import styled from 'styled-components';
import { screenWidth } from 'utility/screen-width';

const FlexWraper = ({
    children
}) => {
    

    return(
        <Wrapper>
            {children}
        </Wrapper>
    )
}

export default FlexWraper;

const Wrapper = styled.div`    
    display: flex;
    gap: 12px;

    > * {
        flex: 1 1 0;
    }
`;
